import { StandardEvents } from '@getvim/vim-connect';
import { analyticsManager } from './analyticsManager';

export const trackReferralViewed = (
  data: StandardEvents.TransformedReferralViewedPayload,
): void => {
  const { specialty, referringProvider, targetProvider } = data;

  analyticsManager.track('order_assist_referral_viewed', {
    icd: data.diagnosis?.map((diagnosis) => ({
      code: diagnosis.code,
      description: diagnosis.description,
    })),
    speciality: specialty
      ? {
          description: specialty.description,
          vimSpecialty: specialty.vimSpecialty
            ? {
                description: specialty.vimSpecialty.description,
                id: specialty.vimSpecialty.id,
              }
            : undefined,
        }
      : undefined,
    referringProvider: referringProvider
      ? {
          npi: referringProvider.npi,
          firstName: referringProvider.demographics?.firstName,
          lastName: referringProvider.demographics?.lastName,
        }
      : undefined,
    targetProvider: targetProvider
      ? {
          npi: targetProvider.npi,
          firstName: targetProvider.demographics?.firstName,
          lastName: targetProvider.demographics?.lastName,
        }
      : undefined,
  });
};
